import React, { useRef, useState } from 'react';
import Alert from 'react-bootstrap/Alert';

const Result = () => {
    return (
        <Alert variant="success" className="success-msg">
            Your Message has been successfully sent.
        </Alert>
    );
};

const FormOne = () => {
    const form = useRef();
    const [result, showResult] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const sendContactForm = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        const formData = {
            name: form.current['contact-name'].value,
            email: form.current['contact-email'].value,
            phone: form.current['contact-phone'].value
        };

        try {
            const response = await fetch('https://ucwf-server-42s2.onrender.com/api/application/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error(`Server responded with status ${response.status}`);
            }

            const data = await response.json();
            form.current.reset();
            showResult(true);
            
            // Hide success message after 5 seconds
            setTimeout(() => {
                showResult(false);
            }, 5000);
        } catch (err) {
            console.error('Error submitting contact form:', err);
            setError('Failed to submit form. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form ref={form} onSubmit={sendContactForm} className="axil-contact-form">
            <div className="form-group">
                <label>Name</label>
                <input 
                    type="text" 
                    className="form-control" 
                    name="contact-name" 
                    placeholder="John Smith" 
                    required 
                />
            </div>
            <div className="form-group">
                <label>Email</label>
                <input 
                    type="email" 
                    className="form-control" 
                    name="contact-email" 
                    placeholder="example@mail.com" 
                    required 
                />
            </div>
            <div className="form-group mb--40">
                <label>Phone</label>
                <input 
                    type="tel" 
                    className="form-control" 
                    name="contact-phone" 
                    placeholder="+123456789" 
                    required 
                />
            </div>
            <div className="form-group">
                <button 
                    type="submit" 
                    className="axil-btn btn-fill-primary btn-fluid btn-primary" 
                    name="submit-btn"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Sending...' : 'Get A Call Back'}
                </button>
            </div>
            <div className="form-group">
                {error && <Alert variant="danger">{error}</Alert>}
                {result ? <Result /> : null}
            </div>
        </form>
    );
};

export default FormOne;